import { APP_BASE_PATH } from '@/app.const'

const OAUTH_CALLBACK_PATH = '/oauth/callback'

/**
 * Builds the OAuth callback URL dynamically from the current origin.
 * Used to tell the backend where Google should redirect after authorization.
 */
export const buildOAuthCallbackUrl = (): string =>
  `${window.location.origin}${APP_BASE_PATH}${OAUTH_CALLBACK_PATH}`
